import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'extra-curricular-activities',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ExtraCurricularActivitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
